// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ayh4","col":"styles_col__S_tYB","fulfillmentStatus":"styles_fulfillmentStatus__3nYwF","emailCol":"styles_emailCol__3tnJ_"};